import React, { useContext, useEffect, useState } from "react";
import LoanRepaymentLogo from "../../../Assets/Images/LoanRepayment.svg";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { Tooltip, Typography, Popover,Button } from "@mui/material";
import { LoaderContext, getContext } from "../../../Helpers/Context/Context";
import { useNavigate } from "react-router-dom";
import { APICall } from "../../../Helpers/Network/APICalls";
import {
  getLoanRequestData,
  getLoanRequestDataForRepayment,
  getRePaymentHistory,
  GetLoanModuleHistory,
  DeleteLoanRequestByLoanId
} from "../../../Helpers/APIEndPoints/EndPoints";
import OverflowTip from "../../../Components/OverflowToolTip/OverflowToolTip";
import moment from "moment";
import { DATE_DISPLAY_FORMAT } from "../../../Helpers/Constants/Constants";
import {
  getActionEditForLoanDashboard,
  getStatusIdsForLoanDashboard,
  getActionEditForLoanRepaymentDashboard,
} from "../Helpers/GridHelper";
import { ILoanApprovalGrid } from "./ILoanApprovalGrid";
import { RoleEnum } from "../../../Helpers/Enums/RoleEnum";
import { LoanDashboardModules } from "../../../Helpers/Enums/LoanDashboardModules";
import notify, { ToastType } from "../../../Helpers/ToastNotification";
import {
  LoanRepayment,
  LoanStatus,
} from "../../../Helpers/Enums/ApplicationStatus";
import { encryptV2 } from "../../../Helpers/Cryptography/CryptoV2";
import { AllRoutes } from "../../../Routes/router";
import { LoanTypeEnum, MODES } from "../../../Helpers/Enums/Enum";
import { useDispatch } from "react-redux";
import { setIsLoanParams } from "../../../Redux/Actions/LoanModuleAction";
import Modal from "react-modal";
import { setUserData } from "../../../Redux/Actions";
Modal.setAppElement("#root"); // Set the root element for accessibility

const LoanApprovalGrid = (props: ILoanApprovalGrid) => {
  const {
    searchText,
    setSearchText,
    activeTab,
    currentFilters,
    dataCount,
    setDataCount,
    setCurrentDataReqObj,
  } = props;
  const context = getContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { showLoader, hideLoader } = useContext(LoaderContext);

  const [sortDirection, setSortDirection] = useState("");
  const [pageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");

  const [historyStart, setHistoryStart] = useState(0);
  const [historyPageSize] = useState(10);
  const [historySortDirection, setHistorySortDirection] = useState("");
  const [historySortColumn, setHistorySortColumn] = useState("");
  const [historyCount, setHistoryCount] = useState(0);

  const [dashboardData, setDashboardData] = useState([]);
  const [dashboardHistoryData, setDashboardHistoryData] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);


  const [historyStartloan, setHistoryStartloan] = useState(0);
  const [historyPageSizeloan] = useState(10);
  const [historySortDirectionloan, setHistorySortDirectionloan] = useState("");
  const [historySortColumnloan, setHistorySortColumnloan] = useState("");
  const [historyCountloan, setHistoryCountloan] = useState(0);

  const [loandashboardHistoryData, setloanDashboardHistoryData] = useState([]);
  const [modalIsOpenloan, setModalIsOpenloan] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  useEffect(() => {
    dispatch(setIsLoanParams({ LoanId: 0, MemberId: 0 }));
  }, []);

  const getDashboardData = async () => {
    showLoader();
    try {
      let statusIds;

      let statusIdArr = getStatusIdsForLoanDashboard(
        activeTab.module,
        context.loggedInAs.value as RoleEnum
      );
      statusIds =
        currentFilters?.status?.value?.toString() || statusIdArr.join(",");

      setCurrentDataReqObj(null);

      let unitCodeIds = "";
      if (context?.CurrentRoleId === RoleEnum.InternalTeam) {
        unitCodeIds = context?.UnitCodeIds;
      }
      const filterUnitCodeIds = currentFilters?.unitCode?.map((v) => v?.value);
      if (filterUnitCodeIds?.length > 0) {
        unitCodeIds = filterUnitCodeIds?.join(",");
      }

      let obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        MemberId:
          (context?.loggedInAs?.value as RoleEnum) === RoleEnum.Member
            ? context?.MemberId
            : 0,
        UnitCodeId: unitCodeIds,
        TypeofApplicantId:
          currentFilters?.typeofApplicant?.map((v) => v?.value)?.join(",") ||
          "",
        FromDate: currentFilters?.fromDate || "",
        ToDate: currentFilters?.toDate || "",
        Status: statusIds,
        IsApproval: [
          LoanDashboardModules.All,
          LoanDashboardModules.Pending,
        ].includes(activeTab.module)
          ? 1
          : 0,
        IsAgreement:
          activeTab.module === LoanDashboardModules.Agreement ? 1 : 0,
        IsFinalDisbursement: 0,
        ActiveModule: [
          LoanDashboardModules.AllRepayment,
          LoanDashboardModules.PendingRepayment,
        ].includes(activeTab.module)
          ? 1
          : 0,
      };

      setCurrentDataReqObj(obj);
      // Orignal code
      // const resp = await APICall(getLoanRequestData, obj);

      // if (resp?.Data?.length > 0) {
      //   setDashboardData(resp?.Data);
      // } else {
      //   setDashboardData([]);
      // }

      // const dataCount = resp?.Data[0]?.TotalCount || resp?.Data?.length || 0;
      // setDataCount(dataCount);

      // Updated Code
      if (activeTab.id === "all-repayment") {
        const resp = await APICall(getLoanRequestDataForRepayment, obj);
        if (resp?.Data?.length > 0) {
          setDashboardData(resp?.Data);
          const dataCount =
            resp?.Data?.[0]?.TotalCount || resp?.Data?.length || 0;
          setDataCount(dataCount);
          hideLoader();

          // setCurrentDataReqObj(obj);
        } else {
          setDashboardData([]);
          setDataCount(0);
          // commit wait
        }
      } else {
        const resp = await APICall(getLoanRequestData, obj);

        if (resp?.Data?.length > 0) {
          setDashboardData(resp?.Data);

          const isAnySuretyReplaced = resp?.Data.reduce(
            (d1, d2) => d1.IsSuretyReplaced || d2.IsSuretyReplaced
          );
          if (context?.IsSuretyReplaced !== isAnySuretyReplaced) {
            let newUserData = { ...context };
            newUserData.IsSuretyReplaced = isAnySuretyReplaced;
            dispatch(setUserData(newUserData));
          }
        } else {
          setDashboardData([]);
        }

        // resp?.Data[0] still throws when Data is null - it only guarded resp.
        const dataCount = resp?.Data?.[0]?.TotalCount || resp?.Data?.length || 0;
        setDataCount(dataCount);
      }
    } catch (err) {
      // Log the real error; the toast below is generic and hides the cause.
      console.error("LoanApprovalGrid.getDashboardData failed:", err);
      notify(
        ToastType.Error,
        "Oops! Something went wrong. We're on it. Please try again later."
      );
    } finally {
      hideLoader();
    }
  };

  const CustomCellComponent = (
    value: any,
    tableMeta: any,
    isDate: boolean = false
  ) => {
    const colName = tableMeta.columnData.name;
    const IsSuretyReplaced = tableMeta.rowData[17];
    const LoanType = tableMeta.rowData[2] === LoanTypeEnum.LONGTERM;
    const showErrorIcon =
      colName === "ApplicationNo" &&
      IsSuretyReplaced === true &&
      context.CurrentRoleId === RoleEnum.Member;
    return (
      <>
        <OverflowTip>
          <Typography
            fontFamily={"Georama-Regular"}
            fontSize={"14px"}
            component={"span"}
            noWrap={true}
          >
            {showErrorIcon && LoanType && (
              <i className="fas fa-exclamation-circle text-danger d-flex align-items-center pr-2"></i>
            )}
            {!isDate
              ? value
              : value
                ? moment(value).format(DATE_DISPLAY_FORMAT)
                : ""}
          </Typography>
        </OverflowTip>
      </>
    );
  };

  const CommonCellOptions = (isDate: boolean = false) => {
    return {
      filter: true,
      sort: true,
      sortDescFirst: true,
      customBodyRender: (value, tableMeta) =>
        CustomCellComponent(value, tableMeta, isDate),
    };
  };

  const Options = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: dataCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => { },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const GridColumns = [
    //0
    {
      name: "LoanRequestId",
      label: "Loan Id",
      options: {
        display: false,
      },
    },
    //1
    {
      name: "StatusId",
      label: "StatusId",
      options: {
        display: false,
      },
    },
    //2
    {
      name: "LoanType",
      label: "LoanType",
      options: {
        display: false,
      },
    },
    //3
    {
      name: "ApplicationNo",
      label: "Loan No",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId === RoleEnum.Member,
        customBodyRender: (value, tableMeta) => {
          const repaymentAmount = tableMeta.rowData[16];
          const IsSuretyReplaced = tableMeta.rowData[17]; //Change discuss by vishrant
          const LoanType = tableMeta.rowData[2] == LoanTypeEnum.LONGTERM;
          debugger;
          return (
            <div>
              <span>
                {activeTab.id === "all-requests" && IsSuretyReplaced && LoanType && (
                  <i
                    className="fa fa-info-circle mr-2"
                    style={{
                      color: "red",
                    }}
                  ></i>
                )}
                {value}
              </span>
            </div>
          );
        },
      },
    },
    //4
    {
      name: "LoanAmount",
      label: "Loan Amount",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId === RoleEnum.Member,
      },
    },
    //5
    {
      name: "RepaymentAmount",
      label: "Approved Amount",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId === RoleEnum.Member,
      },
    },
    //6
    {
      name: "MemberNo",
      label: "Member No",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId !== RoleEnum.Member,
      },
    },
    //7
    {
      name: "Name",
      label: "Name",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId !== RoleEnum.Member,
      },
    },
    //8
    {
      name: "FinalApproverFirst",
      label: "Approver Name",
      options: {
        ...CommonCellOptions(),
        // display: context?.CurrentRoleId !== RoleEnum.Member,
        display: true,
      },
    },
    //9
    {
      name: "ApplicationDate",
      label: "Application Date",
      options: CommonCellOptions(true),
    },
    //10
    {
      name: "LoanTypeName",
      label: "Loan Type",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId === RoleEnum.Member,
      },
    },
    //11
    {
      name: "BalanceAmount",
      label: "Balance Amount",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId === RoleEnum.Member,
      },
    },
    //12
    {
      name: "ApplicationNo",
      label: "Application No.",
      options: {
        ...CommonCellOptions(),
        display: context?.CurrentRoleId !== RoleEnum.Member,
      },
    },
    //13
    {
      name: "DocumentNo",
      label: "Document No.",
      options: {
        ...CommonCellOptions(),
        display: true, //context?.CurrentRoleId === RoleEnum.LoanCommittee,
      },
    },
    //14
    {
      name: "Status",
      label: "Status",
      options: CommonCellOptions(),
    },
    //15
    {
      name: "LpdId",
      label: "Loan Repayment Id",
      options: {
        display: false,
      },
    },
    //16
    {
      name: "RepaymentAmount",
      label: "Repayment Amount",
      options: {
        display: false,
      },
    },
    //17
    {
      name: "IsSuretyReplaced",
      label: "IsSuretyReplaced",
      options: {
        display: false,
      },
    },
    //18
    {
      name: "IsRepaymentAllowed",
      label: "IsRepaymentAllowed",
      options: {
        display: false,
      },
    },
    //19
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          let LoanRequestId = tableMeta.rowData[0];
          let LoanRepaymentId = tableMeta.rowData[15];
          let RepaymentAmount = tableMeta.rowData[16];
          const IsSuretyReplaced = tableMeta.rowData[17];
          const LoanType = tableMeta.rowData[2] == LoanTypeEnum.LONGTERM;
          let shouldShowEdit = false;
          let shouldShowView = false;
          let shouldShowEditRepayment = false;
          let shouldShowViewRepayment = false;
          let IsRepayment = false;
          let currentStatus;

          const IsRepaymentAllowed = tableMeta.rowData[18];

          if (
            [
              LoanDashboardModules.AllRepayment,
              LoanDashboardModules.PendingRepayment,
            ].includes(activeTab.module)
          ) {
            currentStatus = tableMeta.rowData[1] as LoanRepayment;
            let statusIdArrRepayment = getActionEditForLoanRepaymentDashboard(
              context?.CurrentRoleId
            );
            shouldShowEditRepayment =
              statusIdArrRepayment.includes(currentStatus);
            shouldShowViewRepayment = !shouldShowEdit;
            IsRepayment = true;
          } else {
            currentStatus = tableMeta.rowData[1] as LoanStatus;
          
            let statusIdArr = getActionEditForLoanDashboard(
              context?.CurrentRoleId
            );
            shouldShowEdit = statusIdArr.includes(currentStatus);
            shouldShowView = !shouldShowEdit;
          }

          if (IsRepayment) {
            return (
              <>
                {shouldShowViewRepayment &&
                  [
                    LoanRepayment.LoanRepayment_MemberApplyForLoanRepayment,
                    LoanDashboardModules.AllRepayment,
                  ].includes(currentStatus) &&
                  context?.CurrentRoleId === RoleEnum.Member && (
                    <>
                      <Tooltip title="view">
                        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                        <a
                          className="pr-3"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate("/LoanDetailsMemberView", {
                              state: {
                                LoanRequestId: LoanRequestId,
                                LoanRepaymentId: LoanRepaymentId,
                                mode: MODES.VIEW,
                                Status: currentStatus,
                                RepaymentAmount: RepaymentAmount,
                              },
                            });
                          }}
                        >
                          <i className="fas fa-eye"></i>
                        </a>
                      </Tooltip>

                    </>
                  )}
                {shouldShowEditRepayment && (
                  <Tooltip title="edit">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      className="pr-3"
                      onClick={(e) => {
                        e.preventDefault();
                        // navigate("/LoanDetailDashboard", {
                        //   state: { Id: id, mode: MODES.EDIT },
                        // });
                        navigate("/LoanSettlementTabs", {
                          state: {
                            LoanRequestId: LoanRequestId,
                            LoanRepaymentId: LoanRepaymentId,
                            Status: currentStatus,
                            RepaymentAmount: RepaymentAmount,
                          },
                        });
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </a>
                  </Tooltip>
                )}

                <Tooltip title="history">
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      openModal(LoanRequestId, MODES.VIEW);
                    }}
                  >
                    <i className="fa-solid fa-clock-rotate-left"></i>
                  </a>
                </Tooltip>
                {currentStatus === 109 && (
                  <Tooltip title="History">
                    <a
                      className="pr-3"
                      onClick={(e) => {
                        e.preventDefault();
                        openLoanHistoryModal(LoanRequestId); // Replace with appropriate row ID
                      }}
                    >
                      <i className="fa fa-history" aria-hidden="true"></i>
                    </a>
                  </Tooltip>
                )}
              </>
            );
          } else {
            return (
              <>
                {shouldShowView && (
                  <>
                    <Tooltip title="view">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a
                        className="pr-3"
                        onClick={(e) => {
                          e.preventDefault();
                          if (
                            [
                              LoanStatus.LoanModule_SuretyApprovalPending,
                              LoanStatus.LoanModule_SuretyRejectedByMember,
                            ].includes(currentStatus) &&
                            context?.CurrentRoleId === RoleEnum.Member
                          ) {
                            navigate("/LoanDetailDashboard", {
                              state: { Id: LoanRequestId, mode: MODES.VIEW },
                            });
                          } else {
                            navigate("/LoanDetailDashboard", {
                              state: { Id: LoanRequestId, mode: MODES.VIEW },
                            });
                          }
                        }}
                      >
                        <i className="fas fa-eye"></i>
                      </a>
                    </Tooltip>

                    {LoanType &&
                      [LoanStatus.LoanModule_LoanApplicationApproved].includes(
                        currentStatus
                      ) &&
                      (IsSuretyReplaced || IsRepaymentAllowed) &&
                      context?.CurrentRoleId === RoleEnum.Member && (
                        <Tooltip title="Loan EMI Details">
                          <a
                            className="pr-3"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/LoanDetailsMemberView", {
                                state: {
                                  LoanRequestId: LoanRequestId,
                                  LoanRepaymentId: LoanRepaymentId,
                                  mode: MODES.VIEW,
                                  Status: currentStatus,
                                  RepaymentAmount: RepaymentAmount,
                                },
                              });
                            }}
                          >
                            <i className="fas fa-recycle"></i>
                          </a>
                        </Tooltip>
                      )}

                    {/* add new changes  */}
                    {/* {
                      // LoanType &&
                      //   [LoanStatus.LoanModule_LoanApplicationApproved].includes(
                      //     currentStatus
                      //   ) &&
                      //   IsSuretyReplaced &&
                      //   context?.CurrentRoleId === RoleEnum.Member && (
                      IsRepaymentAllowed && context?.CurrentRoleId === RoleEnum.Member && (
                        <Tooltip title="Loan EMI Details">
                          <a
                            className="pr-3"
                            onClick={(e) => {
                              e.preventDefault();
                              navigate("/LoanDetailsMemberView", {
                                state: {
                                  LoanRequestId: LoanRequestId,
                                  LoanRepaymentId: LoanRepaymentId,
                                  mode: MODES.VIEW,
                                  Status: currentStatus,
                                  RepaymentAmount: RepaymentAmount,
                                },
                              });
                            }}
                          >
                            <i className="fas fa-recycle"></i>
                          </a>
                        </Tooltip>
                      )} */}
                  </>
                )}
                {shouldShowEdit && (

                  <Tooltip title="edit">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      className="pr-3"
                      onClick={(e) => {
                        e.preventDefault();
                        if (
                          [
                            LoanStatus.LoanModule_Draft,
                            LoanStatus.LoanModule_RejectedByInternalTeam,
                            LoanStatus.LoanModule_AllSuretyApproved,
                          ].includes(currentStatus) &&
                          context?.CurrentRoleId === RoleEnum.Member
                        ) {
                          navigate("/LoanModule", {
                            state: { Id: LoanRequestId, mode: MODES.EDIT },
                          });
                        } else {
                          navigate("/LoanDetailDashboard", {
                            state: { Id: LoanRequestId, mode: MODES.EDIT },
                          });
                        }
                      }}
                    >
                      <i className="fas fa-edit"></i>
                    </a>
                  </Tooltip>

                )}

                {(currentStatus === 69 || currentStatus === 71) && (  //Loan Application Approved || Loan completed
                  <Tooltip title="History">
                    <a
                      className="pr-3"
                      onClick={(e) => {
                        e.preventDefault();
                        openLoanHistoryModal(LoanRequestId); // Replace with appropriate row ID
                      }}
                    >
                      <i className="fa fa-history" aria-hidden="true"></i>
                    </a>
                  </Tooltip>
                )}
                {currentStatus === 51 && context?.CurrentRoleId === RoleEnum.Member && (   //draft
                  <>
                    <Tooltip title="Delete">
                      <a
                        className="pr-3"
                        onClick={(e) => {
                          e.preventDefault();
                          setAnchorEl(e.currentTarget);
                        }}
                      >
                        <i className="fa fa-trash text-danger" aria-hidden="true"></i>
                      </a>
                    </Tooltip>

                    <Popover
                      open={Boolean(anchorEl)}
                      anchorEl={anchorEl}
                      onClose={() => setAnchorEl(null)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                      }}
                    >
                      <div style={{ padding: "12px", maxWidth: "220px" }}>
                        <p style={{ marginBottom: "10px" }}>
                          Are you sure you want to delete?
                        </p>

                        <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                          <Button size="small" onClick={() => setAnchorEl(null)}>
                            Cancel
                          </Button>
                          <Button
                            size="small"
                            color="error"
                            variant="contained"
                            onClick={() => {
                              setAnchorEl(null);
                               deleteLoanRequestByLoanId(LoanRequestId);
                              //alert("Delete functionality is not implemented yet.");
                            }}
                          >
                            Delete
                          </Button>
                        </div>
                      </div>
                    </Popover>
                  </>
                )}

              </>
            );
          }
        },
      },
    },
  ];

  const HistoryOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: historyCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => { },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        setSortColumn(sortColumn);
        setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  const LoanHistoryOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: historyCount,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    onChangeRowsPerPage: () => { },

    onColumnSortChange: async (sortColumn, sortDirection) => {

      if (sortDirection === "asc") {
        setHistorySortColumnloan(sortColumn);
        setHistorySortDirectionloan(sortDirection);
      }
      if (sortDirection === "desc") {
        setHistorySortColumnloan(sortColumn);
        setHistorySortDirectionloan(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };


  const HistoryGridColumns = [
    {
      name: "Sm_Name",
      label: "Status",
      options: {
        display: true,
      },
    },
    {
      name: "Lph_ModifiedBy",
      label: "ModifiedBy",
      options: {
        display: true,
      },
    },
    {
      name: "Lph_CreatedBy",
      label: "CreatedBy",
      options: {
        display: true,
      },
    },
    {
      name: "Lph_CreatedDate",
      label: "Created Date",
      options: {
        display: true,
        ...CommonCellOptions(true),
      },
    },
    {
      name: "Lph_ModifiedDate",
      label: "Modified Date",
      options: {
        display: true,
        ...CommonCellOptions(true),
      },
    },
  ];

  const openLoanHistoryModal = async (loanRequestId: any) => {
    showLoader();
    try {
      const obj = {
        start: historyStart,
        resultsPerPage: historyPageSize,
        sortColumn: historySortColumn,
        sortDirection: historySortDirection,
        LoanRequestId: loanRequestId,
      };

      const resp = await APICall(GetLoanModuleHistory, obj); // <-- your loan history API
     
      if (resp?.Data?.length > 0) {
        const formattedData = resp.Data.map(item => {
        
          const formattedDate = new Date(item.CreatedDate).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          });
          
          return {
            ...item,
            CreatedDate: formattedDate,
          };
        });
        setloanDashboardHistoryData(formattedData);
      } else {
        setloanDashboardHistoryData([]);
      }

      const dataCount = resp?.Data[0]?.TotalCount || resp?.Data?.length || 0;
      setHistoryCountloan(dataCount);
      setModalIsOpenloan(true);
    } catch (err) {
      notify(ToastType.Error, "Loan History Not Available");
    } finally {
      hideLoader();
    }
  };

  const deleteLoanRequestByLoanId = async (loanRequestId: any) => {
    showLoader();
    try {
      const obj = {      
        LoanRequestId: loanRequestId,
         ModifiedBy: context.Id
      };
     
      const resp = await APICall(DeleteLoanRequestByLoanId, obj); // <-- your loan history API
      notify(ToastType.Success, "Loan request deleted successfully");
      getDashboardData();
    } catch (err) {
      notify(ToastType.Error, "Getting issue while deleting loan request");
    } finally {
      hideLoader();
    }
  };


  const LoanHistoryGridColumns = [
    {
      name: "LoanNumber",
      label: "Loan Number",
      options: {
        display: true,
      },
    },
    {
      name: "PreviousOutstanding",
      label: "Previous Outstanding",
      options: {
        display: true,
      },
    },
    {
      name: "RecoveryAmount",
      label: "Recovery Amount",
      options: {
        display: true,
      },
    },
    {
      name: "CurrentOutstanding",
      label: "Current Outstanding",
      options: {
        display: true,
      },
    },
    {
      name: "ActionType",
      label: "Action Type",
      options: {
        display: true,
      },
    },
    {
      name: "CreatedDate",
      label: "Date",
      options: {
        display: true,
      },
    },
  ];

  useEffect(() => {
    if (activeTab != null) {
      // if (activeTab.module === LoanDashboardModules.Agreement) {
      //   setDashboardData([]);
      // } else {
      getDashboardData();
      //}
    }
  }, [activeTab, start, sortColumn, sortDirection, searchText, currentFilters]);

  const openModal = async (Id: any, Mode: string) => {
    showLoader();
    try {
      let obj = {
        start: historyStart,
        resultsPerPage: historyPageSize,
        sortColumn: historySortColumn,
        sortDirection: historySortDirection,
        LoanRequestId: Id,
      };

      const resp = await APICall(getRePaymentHistory, obj);

      if (resp?.Data?.length > 0) {
        setDashboardHistoryData(resp?.Data);
      } else {
        setDashboardHistoryData([]);
      }

      const dataCount = resp?.Data[0]?.TotalCount || resp?.Data?.length || 0;
      setHistoryCount(dataCount);
      setModalIsOpen(true);
    } catch (err) {
      notify(ToastType.Error, "Data Not Available");
     
    } finally {
      hideLoader();
    }
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };
  const closeLoanModal = () => {
    setModalIsOpenloan(false);
  };

  const customStyles = {
    content: {
      width: "70%", // Set the width of the modal
      height: "auto", // Set the height of the modal
      margin: "auto", // Center the modal horizontally
      overflow: "auto", // Allow modal content to be scrollable if needed
    },
  };

  return (
    <div>
      <DynamicGrid
        options={Options}
        data={dashboardData}
        columns={GridColumns}
      />

      <div>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          contentLabel="Example Modal"
          style={customStyles} // Apply the custom styles
        >
          {/* Header */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h2>Loan Repayment History Data</h2>
            {/* <button onClick={closeModal}>Close</button> */}
          </div>

          <DynamicGrid
            options={HistoryOptions}
            data={dashboardHistoryData}
            columns={HistoryGridColumns}
          />
          {/* Footer */}
          <div
            style={{
              padding: "10px",
              borderTop: "1px solid #ccc",
              textAlign: "right",
            }}
          >
            <button className="btn btn-cancel" onClick={closeModal}>
              Cancel
            </button>
          </div>
          {/* <div>
            <button onClick={closeModal}>Close Modal</button>
          </div> */}
        </Modal>
        <Modal
          isOpen={modalIsOpenloan}
          onRequestClose={closeLoanModal}
          contentLabel="Loan History Modal"
          style={customStyles}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h2>Loan Outstanding History</h2>
          </div>

          <DynamicGrid
            options={LoanHistoryOptions}
            data={loandashboardHistoryData}
            columns={LoanHistoryGridColumns}
          />

          <div
            style={{
              padding: "10px",
              borderTop: "1px solid #ccc",
              textAlign: "right",
            }}
          >
            <button className="btn btn-cancel" onClick={closeLoanModal}>
              Cancel
            </button>
          </div>
        </Modal>

      </div>
    </div>
  );


};

export default LoanApprovalGrid;
